import { Box, Stack, Typography } from '@mui/material';
import BtnIcon from 'components/BtnIcon';
import { ButtonIcon } from 'generated/graphql';
import type { FieldRendererProps } from '../types';

/**
 * A value the form shows but never edits, as plain text rather than a
 * disabled input. Sized like a dense outlined input so it lines up beside one
 * in a horizontal group.
 */
export function ReadonlyField({ field }: FieldRendererProps) {
  return (
    <Stack
      direction="row"
      sx={(theme) => ({
        alignItems: 'center',
        gap: theme.spacing(1.5),
        minHeight: theme.spacing(7),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        minWidth: 0,
      })}
    >
      {field.icon && field.icon !== ButtonIcon.None && (
        <Box sx={(theme) => ({ display: 'flex', flexShrink: 0, color: theme.palette.text.secondary })}>
          <BtnIcon icon={field.icon} size={20} />
        </Box>
      )}
      <Box sx={{ minWidth: 0 }}>
        {field.label && (
          <Typography variant="caption" component="div" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            {field.label}
          </Typography>
        )}
        <Typography variant="body1" noWrap title={field.value}>
          {field.value}
        </Typography>
      </Box>
    </Stack>
  );
}
